import { useRouter } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function BackIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-10 w-[33px] text-white", className)}
      fill="none"
      viewBox="10 0 33 40"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          clipRule="evenodd"
          d="M21.7255 13.5424C22.4183 12.8852 22.4183 11.7815 21.7255 11.1242L21.6876 11.0883C21.0446 10.4782 20.0365 10.4782 19.3934 11.0883L10 20L19.3934 28.9117C20.0365 29.5218 21.0446 29.5218 21.6876 28.9117L21.7255 28.8758C22.4183 28.2185 22.4183 27.1148 21.7255 26.4576L14.9189 20L21.7255 13.5424Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}

export interface MobileBackButtonProps extends React.ComponentProps<"button"> {
  className?: string;
}

export default function MobileBackButton({
  className,
  ...props
}: MobileBackButtonProps) {
  const router = useRouter();

  return (
    <Button
      aria-label="Back"
      className={cn("h-10 w-[33px]", className)}
      onClick={() => router.history.back()}
      {...props}
    >
      <BackIcon />
    </Button>
  );
}
